/* eslint-disable */
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  postPeopleRequest: ['data'],
  postPeopleSuccess: ['response'],
  postPeopleFailure: null,
  postPeopleRequest2: ['search'],
  postPeoplePostRequest: ['userIds'],
  postPeopleComplete: ['stateChanges'],
})

export const PostPeopleTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: false,
  userPosts: null,
  error: null,
  start : 0,
  users: {
    search: null,
    fetching: false,
    start : 0,
    data: null,
    error: null,
    timeStamp: null,
  },
  usersAndPosts: {
    userIds: null,
    fetching: false,
    start : 0,
    data: null,
    error: null,
    timeStamp: null,
  },
})

/* ------------- Selectors ------------- */

export const PostPeopleSelectors = {
  getData: state => state.data
}

/* ------------- Reducers ------------- */

// request the data from an api
export const request = (state, { data }) => {

  return state.merge({ fetching: true, data, userPosts: null, start : Date.now( ) })
}


// successful api lookup
export const success = (state, action) => {

  const { response: { data: { data } } } = action
        , oldPost = state.userPosts
        , start = action.response.start
  if( start < state.start ) return state

  return state.merge({ start : start
    , fetching: false, error: null, userPosts: oldPost != null ? [...oldPost,...data] : data
  })
}

// Something went wrong somewhere.
export const failure = state =>
  state.merge({ fetching: false, error: true, userPosts: null })


// NEW

export const requestUsers = (state, { search }) => {
  return state.merge({users: Object.assign({}, state.users, { fetching: true, search, data: null, error: null, start : Date.now() })})
}

export const requestPosts = (state, { userIds }) => {
  console.tron.display({name: `PostPeopleRedux`, preview: `requestPosts`, value: { userIds: userIds } })
  return state.merge({usersAndPosts: Object.assign({}, state.usersAndPosts, { fetching: true, userIds, data: null, error: null, start : Date.now() })})
}

export const requestComplete = (state, action) => {
  const stateChanges = action.stateChanges
  console.tron.display({name: `PostPeopleRedux`, preview: `requestComplete`, value: { action: action, stateChanges: stateChanges } })
  return state.merge(stateChanges)
/*
  const { response: { data: { data } } } = action
        , oldPost = state.userPosts
        , start = action.response.start
  if( start < state.start ) return state

  return state.merge({ start : start
    , fetching: false, error: null, userPosts: oldPost != null ? [...oldPost,...data] : data
  })
*/  
}


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {  
  [Types.POST_PEOPLE_REQUEST]: request,
  [Types.POST_PEOPLE_SUCCESS]: success,
  [Types.POST_PEOPLE_FAILURE]: failure,
  [Types.POST_PEOPLE_REQUEST2]: requestUsers,
  [Types.POST_PEOPLE_POST_REQUEST]: requestPosts,
  [Types.POST_PEOPLE_COMPLETE]: requestComplete,
})
